<template>
  <div class="invite-team" >
    <div class="captain">
      <!-- 队长管理的多个球队 start -->
      <div class="user" v-if="!teamId && myOrgTeams && myOrgTeams.length > 0">
        <div class="isShowTeam" >
          <h3>我的参赛球队</h3>
          <p>您有多个参赛的球队，请完成队员信息收集</p>
        </div>
        <div class="teams" v-for="(item) in myOrgTeams" :key="item.id"  @click="goManageTeam(item.teamId)">
          <div>
            <img v-if="item.badge" :src="formatterImgSrc(item.badge)" >
            <img v-else src="@/assets/images/team-logo-empty.png" />
          </div>
          <div>
            <p>{{ item.teamName }}</p>
            <span>{{ item.playerCount }}人</span>
          </div>
        </div>
      </div>
      <!-- end -->

      <!-- 待认领球队 start -->
      <div v-if="!teamId && myConfirmTeams.length > 0 && myOrgTeams && myOrgTeams.length == 0" class="user" >
        <div class="isShowTeam" >
          <h3>待认领球队！</h3>
          <p>若确认你是已参赛球队，看看赛事是否给你创建了球队，选择球队认领或替换。没有请联系赛事方</p>
        </div>
        <div class="teams" v-for="(item) in myConfirmTeams" :key="item.id" @click="confirmTeam(item.teamId)" >
          <div>
            <img v-if="item.badge" :src="formatterImgSrc(item.badge)" >
            <img v-else src="@/assets/images/team-logo-empty.png" />
          </div>
          <div>
            <p>{{ item.teamName }}</p>
            <span>待认领</span>
          </div>
        </div>
      </div>
      <!-- end -->

      <!-- empty start -->
      <div class="isShowTeam" v-if="myOrgTeams && myOrgTeams.length == 0 && myConfirmTeams.length == 0">
        <h3>你没有参赛球队！</h3>
        <p>若确认你是已参赛球队，请联系赛事方</p>
      </div>
      <!-- end -->

      <!-- 一个球队 start -->
      <div v-if="teamId">
        <div class="team">
          <div>
            <img v-if="team.badge" :src="formatterImgSrc(team.badge)" >
            <img v-else src="@/assets/images/team-logo-empty.png" />
          </div>
          <div>
            <p>{{ team.name }}</p>
            <span>{{ team.location }}</span>
          </div>
          <div>
            <span @click="routerTeamEdit" >编辑</span>
          </div>
        </div>
        <!-- 教练 start -->
        <div class="title">
          球队官员（{{ officer.length }}人）
          <span @click="routerTeamOfficer()" >添加</span>
        </div>
        <div class="list" v-if="officer.length > 0" >
          <van-swipe-cell v-for="(item) in officer" :key="item.id" :right-width="48">
            <div class="team player" @click="routerTeamOfficer(item.id)" >
              <div>
                <img class="thumb" v-if="item.avatar || item.photo" :src="formatterImgSrc(item.avatar || item.photo)">
                <img class="thumb" v-else src="@/assets/images/player-logo-empty.png" />
              </div>
              <div>
                <p>{{item.name}}</p>
                <span>{{item.role}}</span>
              </div>
              <div>
                <span>{{ item.desc }}</span>
              </div>
            </div>
            <span slot="right" class="remove" @click="removeOfficer(item.id)">删除</span>
          </van-swipe-cell>
          <div style="width: 100%; height: 20px;" ></div>
        </div>
        <!-- 教练 end -->
        <div class="title">
          参赛球员（{{ playerList.length }}人）
          <span @click="routerTeamPlayer" >编辑</span>
        </div>
        <div class="list" v-if="playerList.length > 0" >
          <van-swipe-cell v-for="(item) in playerList" :key="item.id" :right-width="48">
            <div class="team player" @click="routerPlayerEdit(item.id)" >
              <div>
                <img class="thumb" v-if="item.avatar || item.photo" :src="formatterImgSrc(item.avatar || item.photo)">
                <img class="thumb" v-else src="@/assets/images/player-logo-empty.png" />
              </div>
              <div>
                <p>{{item.trueName}}</p>
                <span v-if="item.number" >{{item.number}}号</span>
              </div>
              <div>
                <span>{{ item.desc }}</span>
              </div>
            </div>
            <span slot="right" class="remove" @click="removePlayer(item.id)">删除</span>
          </van-swipe-cell>
          <div style="width: 100%; height: 100px;" ></div>
        </div>
        <div class="value" v-if="playerList.length == 0" >
          <h3>暂无参赛球员</h3>
          <p>若需要编辑的参赛球员资料太多，你可以点击“邀请队员编辑个人资料”分享个人资料编辑页面到球队群让队员自行编辑</p>
        </div>
      </div>
      <!-- end -->
    </div>
    <div class="foot" v-if="teamId" @click="share()" >
      <a>
        邀请球员完善资料
      </a>
    </div>

    <van-popup
      v-model="isShowPopup"
      position="bottom" >
      <van-picker
        :columns="columns"
        show-toolbar
        @cancel="isShowPopup = false"
        @confirm="onChange">
      </van-picker>
    </van-popup>

    <!--<van-cell-group> 跳转链接
      <van-cell title="球队编辑" to="/participate/team-edit?teamId=2423&matchId=16" />
      <van-cell title="选择参赛球员" to="/invite-team-edit/captain/player-list" />
      <van-cell title="编辑队员信息" to="/player/edit?playerId=25540&teamId=2423&matchId=16" />
    </van-cell-group>
    普通用户进入一面
    <van-cell-group>
      <van-cell title="认领" to="/invite-team-edit/user/claim" />
      <van-cell title="替换" to="/invite-team-edit/user/replace" />
    </van-cell-group>-->

    <van-popup class="guidePopup" v-model="isShowGuidePopup">
      <img src="@/assets/images/guide.png">
    </van-popup>

  </div>
</template>

<script>
import Vue from 'vue'
import filter from 'lodash/filter'
import { ImageFormat, AppType } from '@/utils/'
import { getMatchInfo } from '@/api/match'
import { callShare } from '@/libs/ds-bridge'
import { getBMTeamPlayerList, getBMPlayerList, getBMMatchTeamList,
  deleteBMPlayer, getBMTeamListByUserId, getBMMatchTeamOfficerList, matchOrganizationDeleteTeamOfficer } from '@/api/team'
import {Cell, CellGroup, SwipeCell, Toast, Popup, Picker, Dialog} from 'vant'
Vue.use(Cell).use(CellGroup).use(SwipeCell).use(Toast).use(Popup).use(Picker).use(Dialog)

export default {
  name: 'InviteTeam',
  inject: ['reload'],
  data() {
    return {
      query: this.$route.query,
      team: false,
      data: null,
      shareData: {},
      teamId: '',
      matchId: '',
      playerId: '',
      playerList: [],
      checkIn: true,
      isShowPopup: false,
      columns: ['替换', '认领'],
      myOrgTeams: null,
      myConfirmTeams: [],
      myOwnTeams: [],
      verifyCode: '',
      selectTeamId: null,
      isShowGuidePopup: false,
      officer: []
    }
  },
  computed: {
    formatterImgSrc() {
      return function(src) {
        return ImageFormat.imageView(src, 104, 104)
      }
    }
  },
  created() {
    this.popupLoading.loading()
    this.teamId = this.query.teamId
    this.matchId = this.query.matchId
    if (this.matchId && this.teamId) {
      this.getBMPlayerList()
    }
    if (this.matchId) {
      this.getBMMatchTeamList()
      this.getBMMatchTeamOfficerList()
    }
  },
  methods: {
    removePlayer (playerId) {
      Dialog.confirm({
        title: '操作',
        message: '确认删除该球员'
      }).then(() => {
        // on confirm
        const params = {
          playerId: playerId,
          matchId: this.matchId,
          teamId: this.teamId
        }
        deleteBMPlayer(params).then(response => {
          Toast('删除球员成功')
          this.getBMTeamPlayerList()
        })
      }).catch(() => {
        // on cancel
      })
    },
    removeOfficer (officerId) {
      Dialog.confirm({
        title: '操作',
        message: '确认删除该官员'
      }).then(() => {
        // on confirm
        const params = {
          officerId: officerId,
          matchId: this.matchId,
          teamId: this.teamId
        }
        matchOrganizationDeleteTeamOfficer(params).then(response => {
          Toast('删除官员成功')
          this.getBMMatchTeamOfficerList()
        })
      }).catch(() => {
        // on cancel
      })
    },
    routerTeamEdit() {
      this.$router.push({
        path: '/participate/team-edit',
        query: {
          teamId: this.teamId,
          matchId: this.matchId,
          type: 'invite-team'
        }
      })
    },
    goManageTeam(teamId) {
      this.teamId = teamId
      this.$router.push({
        name: 'InviteTeamInfo',
        query: {
          matchId: this.matchId,
          teamId: this.teamId
        }
      })
      this.getBMPlayerList()
      this.getBMTeamPlayerList()
    },
    routerTeamPlayer() {
      this.$router.push({
        path: '/invite-team-edit/captain/player-list',
        query: {
          teamId: this.teamId,
          matchId: this.matchId
        }
      })
    },
    routerTeamOfficer(officerId) {
      this.$router.push({
        path: '/player/officer-edit',
        query: {
          teamId: this.teamId,
          matchId: this.matchId,
          officerId: officerId
        }
      })
    },
    getBMPlayerList() {
      let params = {
        teamId: this.teamId,
        matchId: this.matchId
      }
      getBMPlayerList(params).then((response) => {
        // let data = response.data
        this.popupLoading.clear()
        this.getBMTeamPlayerList()
      })
    },
    getShareLink: function () {
      const arr = window.location.href.split('index.html')
      let shareUrl = arr[0] + 'index.html#/invite-player?teamId=' + this.teamId + '&matchId=' + this.matchId
      const match = this.data.match
      if (match && match.association && match.association.id) {
        shareUrl = arr[0] + 'index.html#/participate/player-apply?teamId=' + this.teamId + '&matchId=' + this.matchId
      }
      return shareUrl
    },
    getBMTeamPlayerList() {
      let params = {
        teamId: this.teamId,
        matchId: this.matchId
      }
      getBMTeamPlayerList(params).then(response => {
        const data = response.data
        this.team = data.team
        this.playerList = data.players
        this.getMatchInfo()
      })
    },
    routerPlayerEdit(playerId) {
      this.$router.push({
        path: '/player/edit',
        query: {
          teamId: this.teamId,
          matchId: this.matchId,
          playerId: playerId
        }
      })
    },
    confirmTeam(teamId) {
      this.selectTeamId = teamId
      this.isShowPopup = true
    },
    onChange(value, index) {
      if (value === '替换' && index === 0) {
        /*
        if (this.myOwnTeams.length === 0) {
          Toast('您没有可替换球队')
          return
        }
        */
        this.$router.push({
          path: '/invite-team-edit/user/replace',
          query: {
            teamId: this.selectTeamId,
            matchId: this.matchId
          }
        })
      } else if (value === '认领' && index === 1) {
        this.$router.push({
          path: '/invite-team-edit/user/claim',
          query: {
            teamId: this.selectTeamId,
            matchId: this.matchId,
            code: this.verifyCode
          }
        })
      }
    },
    getBMMatchTeamList() {
      let params = {
        matchId: this.matchId
      }
      getBMMatchTeamList(params).then(response => {
        this.popupLoading.clear()
        const data = response.data
        this.verifyCode = data.match.verifyCode
        this.myOrgTeams = filter(data.teams, function (item) {
          return item.relationTeam >= 80 && item.auditStatus === 2
        })
        if (this.myOrgTeams.length === 1) {
          this.goManageTeam(this.myOrgTeams[0].teamId)
          return
        }
        this.myConfirmTeams = filter(data.teams, function (item) {
          return item.leaderCount <= 0
        })
        this.getBMTeamListByUserId()
      })
    },
    getBMTeamListByUserId() {
      getBMTeamListByUserId({}).then(response => {
        const data = response.data
        this.myOwnTeams = filter(data.teams, function (item) {
          return item.relationTeam >= 80
        })
      })
    },
    getMatchInfo: function() {
      getMatchInfo(this.query.matchId).then(response => {
        const data = this.data = response.data
        const url = this.getShareLink()
        const match = data.match
        let title = this.team.name + '参赛队员资料收集'
        let shareLogo = this.team.badge
        if (match.association && match.association.id) {
          title = match.association.name + '赛事注册报名'
          shareLogo = match.icon
        }
        this.shareData = {
          title: title,
          link: url,
          image: ImageFormat.squareImageView(shareLogo, 120),
          abstract: match.chineseFullName
        }
        this.wxShare(this.shareData)
      })
    },
    share() {
      let url = this.getShareLink()
      const match = this.data.match
      let title = this.team.name + '参赛队员资料收集'
      let shareLogo = this.team.badge
      if (match.association && match.association.id) {
        title = match.association.name + '赛事注册报名'
        shareLogo = match.icon
      }
      let share = {
        title: title,
        desc: match.chineseFullName,
        link: url,
        imgUrl: ImageFormat.squareImageView(shareLogo, 120)
      }
      if (AppType.isInApp()) {
        callShare(share)
      } else {
        this.isShowGuidePopup = true
      }
    },
    getBMMatchTeamOfficerList() {
      let params = {
        teamId: this.teamId,
        matchId: this.matchId
      }
      getBMMatchTeamOfficerList(params).then(response => {
        const data = response.data
        this.officer = data.officer
      })
    }
  },
  watch: {
    '$route': function() {
      this.reload()
    }
  }
}
</script>

<style lang="stylus" >
.invite-team
  background-color white
  .team
    display flex
    padding 15px
    div:first-child
      width 52px
      height 52px
      margin-right: 10px
      img
        width 52px
        height 52px
    div:nth-child(2)
      display flex
      flex-direction column
      justify-content: space-between;
      width: calc(100% - 112px)
      p
        margin: 0;
        font-size:14px;
        font-weight:400;
        color:rgba(0,0,0,1);
      span
        font-size:12px;
        font-weight:400;
        color:rgba(129,129,129,1);
    div:last-child
      width: 50px
      position relative
      span
        text-align center
        border-radius:14px;
        border:1px solid rgba(242,242,242,1);
        font-size: 12px;
        font-weight: 400;
        color: rgba(155,155,155,1);
        height: auto;
        width 100%;
        padding: 3px 0px;
        position absolute;
        top 50%
        left 50%
        transform translate(-50%, -50%)
  .title
    font-size:18px;
    font-family:PingFangSC-Regular;
    font-weight:400;
    color:rgba(0,0,0,1);
    padding: 10px 15px;
    span
      border-radius:14px;
      border:1px solid rgba(242,242,242,1);
      float: right
      font-size:12px;
      font-family:PingFangSC-Regular;
      font-weight:400;
      color:rgba(155,155,155,1);
      padding: 3px 13px;
  .player
    position relative
    padding 10px 15px
    div:last-child
      display flex
      justify-content center
      align-items: center;
      span
        border: none
        color: #EC4E4E
    div:first-child
      text-align center
      height: 40px
      .thumb
        width: 40px
        height: 40px
        border-radius: 50%;
  .player::before
    content "";
    position absolute
    height: 1px
    width calc(100% - 30px)
    background-color #F2F2F2
    bottom: 0
  .remove
    background-color #EC4E4E
    width 48px
    height: 100%
    text-align center
    font-size:12px;
    font-weight:400;
    color:rgba(255,255,255,1)
    display: flex
    justify-content: center;
    align-items: center;
  .value
    h3
      font-size:30px;
      font-weight:400;
      color:rgba(0,0,0,1);
      text-align center
      margin-bottom: 10px
    p
      margin: 0;
      font-size:14px;
      font-weight:300;
      color:rgba(74,74,74,1);
      line-height:20px;
      padding 0 15px;
  .foot
    padding: 10px 0
    background: rgba(250,250,250,1);
    color: #32A377
    font-size 20px
    text-align center
    position fixed
    bottom: 0
    width: 100%
    max-width 480px
    a
      font-size:18px;
      font-family:PingFangSC-Regular;
      font-weight:400;
      color:rgba(50,163,119,1);
  .isShowTeam
    padding: 15px;
    h3
      font-size:30px;
      font-weight:400;
      color:rgba(0,0,0,1);
      margin: 0;
    p
      font-size:16px;
      font-weight:300;
      color:rgba(0,0,0,1);
      margin: 0;
  .teams
    display flex
    padding 15px
    div:first-child
      width 52px
      height 52px
      margin-right: 10px
      img
        width 52px
        height 52px
    div:last-child
      display flex
      flex-direction column
      justify-content: space-between;
      width: calc(100% - 62px)
      p
        margin: 0;
        font-size:14px;
        font-weight:400;
        color:rgba(0,0,0,1);
      span
        font-size:12px;
        font-weight:400;
        color:rgba(129,129,129,1);
  .guidePopup
    background-color transparent
    width calc(100% - 100px)
    max-width: 480px
    top: 0px
    transform: translate3d(-50%,0%,0);
    img
      width 100%
  .list
    background-color white
</style>



// WEBPACK FOOTER //
// src/pages/invite-team/info.vue